import { lazy, Suspense, type ReactNode } from 'react';
import type { JsonDiffProps } from './types';

const JsonDiff = lazy(() => import('./JsonDiff'));

type Props = JsonDiffProps & {
    readonly fallback?: ReactNode;
};

const JsonDiffLazy = ({ fallback, ...restProps }: Props) => (
    <Suspense
        fallback={fallback ?? (
            <div>Loading...</div>
        )}
    >
        <JsonDiff
            {...restProps}
        />
    </Suspense>
);

export default JsonDiffLazy;
